/**
 * Where a public ticketed event lives (Event Tickets plan 2026-10-19, U4).
 * Under the gym's program catalog, so it shares the catalog's public prefix.
 */

export function publicEventPath(gymSlug: string, eventId: string): string {
  return `/programs/${encodeURIComponent(gymSlug)}/events/${encodeURIComponent(eventId)}`;
}

/** The staff door poster for the same event (R26). */
export function publicEventPosterPath(gymSlug: string, eventId: string): string {
  return `${publicEventPath(gymSlug, eventId)}/poster`;
}
